import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { CONSENSUS_RATE_TOOLTIP } from '@/components/review/consensus';

type Props = {
  /** Icon font size in px */
  iconSize?: number;
};

export default function ConsensusRateInfoIcon({ iconSize = 16 }: Props) {
  return (
    <Tooltip title={CONSENSUS_RATE_TOOLTIP} arrow placement="top">
      <IconButton
        size="small"
        aria-label="共識% 計算說明"
        sx={{ p: 0.25, color: 'text.secondary', verticalAlign: 'middle' }}
        onClick={(e) => e.stopPropagation()}
      >
        <InfoOutlinedIcon sx={{ fontSize: iconSize }} />
      </IconButton>
    </Tooltip>
  );
}
